import React from "react";
import { StyleSheet, View } from "react-native";
import moment from "moment";
import DayCircle from "./DayCircle";
import { useDispatch, useSelector } from "react-redux";
import {
  getLanguage,
  getReminderDays,
} from "@microdoing/shared/services/profileSettings/selectors";
import { changeUserInfo } from "@microdoing/shared/services/profileSettings/actions";
import { widthPercentageToDP } from "react-native-responsive-screen";
import { Box } from "app/components/common";

const weeks = [1, 2, 3, 4, 5, 6, 7];

const getWeekFormat = (index, language) => {
  // English versus French weekLanguage;
  const weekDay = language === "fr" ? index : index;
  return (
    moment()
      .locale(language)
      .isoWeekday(weekDay)
      .format("dddd")
      .slice(0, 2)
      .toUpperCase()
      .charAt(0) +
    moment().locale(language).isoWeekday(weekDay).format("dddd").slice(1, 2)
  );
};

const ReminderDays = ({}) => {
  const language = useSelector(getLanguage);
  const reminderDays = useSelector(getReminderDays) || {
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: false,
    7: false,
  };
  const dispatch = useDispatch();

  const onPressDay = day => () => {
    dispatch(
      changeUserInfo({
        reminderDays: { ...reminderDays, [day]: !reminderDays[day] },
      }),
    );
  };

  return (
    <Box
      alignSelf="center"
      width="100%"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      flexDirection="row"
    >
      {weeks.map(el => (
        <DayCircle
          key={el}
          text={getWeekFormat(el, language)}
          onPress={onPressDay(el)}
          isSelected={reminderDays[el]}
        />
      ))}
    </Box>
  );
};

export default ReminderDays;
